(() => {
  const productId = 15189288812914;
  const deadline = () => Date.parse(document.querySelector('[data-deadline]')?.dataset.deadline || '2026-10-01T23:59:59+07:00');
  const active = () => Date.now() < deadline();
  const root = () => window.Shopify.routes.root;
  const stored = (key, value) => { try { if (value !== undefined) sessionStorage.setItem(key, value); return sessionStorage.getItem(key); } catch { return null; } };
  let mutationQueue = Promise.resolve();
  const enqueue = (task) => { const result = mutationQueue.then(task); mutationQueue = result.catch(() => {}); return result; };
  async function request(route, body) {
    const response = await fetch(root() + route, {method: body ? 'POST' : 'GET', headers: {'Content-Type':'application/json', Accept:'application/json'}, ...(body ? {body:JSON.stringify(body)} : {})});
    const result = await response.json();
    if (!response.ok || result.status >= 400) throw new Error('Unable to update cart');
    return result;
  }
  function sectionTargets() {
    const targets = [{id:'cart-drawer', selector:'#CartDrawer'}, {id:'cart-icon-bubble', selector:'#cart-icon-bubble'}];
    const items = document.querySelector('cart-items');
    const itemsId = items?.dataset.id || items?.closest('.shopify-section')?.id.replace('shopify-section-', '');
    const footerId = document.querySelector('#main-cart-footer')?.dataset.id;
    if (itemsId) targets.push({id:itemsId, selector:'#shopify-section-'+itemsId});
    if (footerId) targets.push({id:footerId, selector:'#shopify-section-'+footerId});
    return targets;
  }
  function renderCart(result, targets) {
    if (!result.sections) return;
    targets.forEach(target => {
      if (!result.sections[target.id]) return;
      const current = document.querySelector(target.selector);
      const parsed = new DOMParser().parseFromString(result.sections[target.id], 'text/html');
      const incoming = parsed.querySelector(target.selector) || parsed.querySelector('.shopify-section');
      if (current && incoming) current.innerHTML = incoming.innerHTML;
    });
    const drawer = document.querySelector('cart-drawer');
    drawer?.classList.toggle('is-empty', result.item_count === 0);
    drawer?.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
    document.querySelector('cart-items')?.classList.toggle('is-empty', result.item_count === 0);
    document.querySelector('#main-cart-footer')?.classList.toggle('is-empty', result.item_count === 0);
    window.Shopify?.PaymentButton?.init();
  }
  function giftFor(cart) {
    const luggage = cart.items.filter(item => item.product_id === productId);
    const count = luggage.reduce((n,item) => n + item.quantity, 0);
    return active() && count >= 2 ? `1 × 20-inch suitcase in ${luggage[0].variant_title}. FREE. One per order; requires two luggage sets.` : '';
  }
  async function recordGift(cart) {
    cart ||= await request('cart.js');
    const gift = giftFor(cart);
    if ((cart.attributes['Vellaroam bonus gift'] || '') !== gift) cart = await request('cart/update.js', {attributes:{'Vellaroam bonus gift':gift}});
    return cart;
  }
  class VellaroamOffer extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.quantity = 1;
      this.claimed = stored('vellaroam-claim') === this.dataset.code && active();
      this.addEventListener('change', event => {
        if (event.target.matches('.vr-pack-options input')) { this.quantity = Number(event.target.value); this.sync(); }
      });
      this.querySelector('[data-vr-claim]')?.addEventListener('click', () => this.claim());
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
        if (String(data.sectionId) === String(this.closest('product-info')?.dataset.section)) this.sync();
      });
      requestAnimationFrame(() => this.sync());
    }
    disconnectedCallback() { this.unsubscribe?.(); }
    money(cents) { return new Intl.NumberFormat('en-US', {style:'currency', currency:this.dataset.currency}).format(cents/100); }
    sync() {
      const form = document.getElementById(this.dataset.form);
      if (!form) return;
      if (!active()) { this.quantity = 1; this.claimed = false; this.querySelector('input[value="1"]').checked = true; }
      const quantity = form.querySelector('[data-vr-quantity]');
      if (quantity && quantity.value !== String(this.quantity)) {quantity.value = String(this.quantity); quantity.dispatchEvent(new Event('change', {bubbles:true}));}
      const color = this.closest('product-info').querySelector('[data-selected-value]')?.textContent.trim() || '';
      const property = form.querySelector('[data-vr-gift-property]');
      if (property) { property.disabled = this.quantity < 2 || !active(); property.value = `1 × 20-inch suitcase in ${color}. FREE with two sets. One per order.`; }
      const discount = form.querySelector('[data-vr-discount-input]');
      if (discount) {discount.disabled = !this.claimed; discount.value = this.dataset.code;}
      const product = this.closest('product-info');
      const submit = form.querySelector('button[name="add"]');
      const submitLabel = submit?.querySelector('span');
      const purchaseLabel = this.quantity === 2 ? product.dataset.vrAddTwo : product.dataset.vrAddOne;
      if (submitLabel && purchaseLabel && !submit.disabled && submitLabel.textContent.trim() !== purchaseLabel) submitLabel.textContent = purchaseLabel;
      const unit = Number(this.dataset.unit);
      const one = unit - (this.claimed ? 1000 : 0);
      const two = unit * 2 - 1999 - (this.claimed ? 1000 : 0);
      this.querySelector('[data-vr-one-price]').textContent = this.money(one);
      const twoPrice = this.querySelector('[data-vr-two-price]'); if (twoPrice) twoPrice.textContent = this.money(two);
      const selected = this.querySelector('.vr-offer-price'); if (selected) selected.textContent = this.money(this.quantity === 2 ? two : one);
      const gift = this.querySelector('[data-vr-gift-benefit]'); if (gift) gift.hidden = this.quantity !== 2 || !active();
      const button = this.querySelector('[data-vr-claim]');
      if (button && this.claimed) {button.textContent = button.dataset.claimedLabel; button.disabled = true;}
    }
    async claim() {
      const button = this.querySelector('[data-vr-claim]');
      const error = this.querySelector('.vr-offer-error');
      button.disabled = true; error.textContent = '';
      try {
        if (!active()) {this.sync(); return;}
        const targets = sectionTargets();
        const cart = await enqueue(() => request('cart/update.js', {discount:this.dataset.code, sections:targets.map(t=>t.id), sections_url:location.pathname}));
        stored('vellaroam-claim', this.dataset.code); this.claimed = true; this.sync(); renderCart(cart, targets);
        publish(PUB_SUB_EVENTS.cartUpdate, {source:'vellaroam-offers', cartData:cart});
      } catch {error.textContent = 'We couldn’t apply the offer. Please try again.';button.disabled = false;}
    }
  }
  if (!customElements.get('vellaroam-offer')) customElements.define('vellaroam-offer', VellaroamOffer);
  class VellaroamCartOffer extends HTMLElement {
    connectedCallback() {this.querySelector('[data-vr-upgrade]')?.addEventListener('click', () => this.upgrade());}
    async upgrade() {
      const button = this.querySelector('button'); button.disabled = true;
      try {
        if (!active()) {this.hidden = true; return;}
        const targets = sectionTargets();
        const cart = await enqueue(async () => {
          await request('cart/add.js', {items:[{id:Number(this.dataset.variant), quantity:1, ...(this.dataset.tag ? {properties:{'Free personalized tag':this.dataset.tag}} : {})}]});
          await recordGift();
          return request('cart/update.js', {sections:targets.map(t=>t.id), sections_url:location.pathname});
        });
        renderCart(cart, targets);publish(PUB_SUB_EVENTS.cartUpdate, {source:'vellaroam-offers', cartData:cart});
      } catch {this.querySelector('.vr-offer-error').textContent = 'We couldn’t add the second set. Please try again.';button.disabled = false;}
    }
  }
  if (!customElements.get('vellaroam-cart-offer')) customElements.define('vellaroam-cart-offer', VellaroamCartOffer);
  function tick() {
    const seconds = Math.max(0, Math.floor((deadline() - Date.now()) / 1000));
    const values = {days:Math.floor(seconds/86400),hours:Math.floor(seconds%86400/3600),minutes:Math.floor(seconds%3600/60),seconds:seconds%60};
    document.querySelectorAll('[data-vr-time]').forEach(e => {const next=String(values[e.dataset.vrTime]).padStart(2,'0');if(e.textContent!==next)e.textContent=next;});
    if (!seconds) {
      document.querySelectorAll('[data-vr-active-offer], vellaroam-cart-offer').forEach(e => e.hidden=true);
      document.querySelectorAll('vellaroam-offer').forEach(e=>e.sync());
    }
  }
  document.addEventListener('click', event => {
    const control=event.target.closest('[data-vr-gallery-step]'); if(!control) return;
    const gallery=control.closest('media-gallery'); const thumbs=[...gallery.querySelectorAll('.thumbnail')]; const current=thumbs.findIndex(t=>t.getAttribute('aria-current')==='true'); const index=(current+Number(control.dataset.vrGalleryStep)+thumbs.length)%thumbs.length; thumbs[index]?.click();
  });
  function initialize() {
    tick();
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => enqueue(() => recordGift()).catch(() => {}));
    enqueue(() => recordGift()).catch(() => {});
    setInterval(tick, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
})();
